import { render } from "./config.vue?vue&type=template&id=33f46ef9&scoped=true&ts=true"
import script from "./config.vue?vue&type=script&lang=ts"
export * from "./config.vue?vue&type=script&lang=ts"

import "./config.vue?vue&type=style&index=0&id=33f46ef9&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f46ef9"]])

export default __exports__